var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.disallow ? 'disallowed': '',attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.click()}}},[_vm._t("default"),_vm._t("text"),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }